import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../components/Loader';
import BtnStandard from "../components/BtnStandard"
import { useSearchParams } from "react-router-dom";
import paiement1 from "../assets/logos/paiement1.png";
import paiement2 from "../assets/logos/paiement2.png";
import paiement3 from "../assets/logos/paiement3.png";
import paiement4 from "../assets/logos/paiement4.png";
import moment from "moment";
import close from "../assets/icones/close-white.png"
const ProductPay = () => {

    const { name } = useParams();
    const [searchParams] = useSearchParams();
    const aid = searchParams.get("aid");
    const brand = searchParams.get("brand");
    const [product, setProduct] = useState(null)
    const [errorProduct,setErrorProduct]=useState(false)
    const [load, setLoad] = useState(true)
    const [select, setSelect] = useState(null);
    const [loadBtn, setLoadBtn] = useState(false)
    const [error, setError] = useState(false)
    const [iframePay, setIframePay] = useState("")
    const [device,setDevice]=useState("")
    const iframeRef = useRef(null);

    const [credentials, setCredentials] = useState({
        name: "",
        firstname: "",
        email: "",
        lastDatePremium: null
    })
    const detectDevice = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
        if (/android/i.test(userAgent)) {
          return "Android";
        }
      
        if (/iPhone|iPad|iPod/i.test(userAgent)) {
          return "iOS (Apple)";
        }
      
        if (/Macintosh|Mac OS X/i.test(userAgent)) {
          return "MacBook";
        }
      
        if (/Windows NT/i.test(userAgent)) {
          return "Windows";
        }
      
        return "Inconnu";
      }
    const handleChange = (e) => {
        const { name, value } = e.currentTarget;
        setCredentials({ ...credentials, [name]: value })
    }
    const init = async () => {
       
       
        try {
            const response = await axios.post(process.env.REACT_APP_API + '/product_routes/get_by_id', { token_brand: brand, aid: aid })


            if (response?.data) {
                setProduct(response.data?.items)
                const matchByName = response.data.items.find(e => e.name == name);
                setSelect(matchByName)
                /** GET INFO USER */
                const urlCallInfoUser = response.data.url_search_user;
                const getInfoUser = await axios.get(urlCallInfoUser);
                if (getInfoUser?.data?.email) {
                    setCredentials({
                        ...credentials,
                        email: getInfoUser.data.email,
                        lastDatePremium: getInfoUser.data.lastPremium
                    })
                }else{
                    setErrorProduct(true)
                }
            }
        } catch (err) {
            setProduct(null)
            setErrorProduct(true)
        }
        setLoad(false);
    }
    const submit = async () => {
        if (credentials.name
            && credentials.firstname
            && credentials.email
            && credentials.name.trim().length > 0
            && credentials.firstname.trim().length > 0
            && credentials.email.trim().length > 0 && !loadBtn) {
            setLoadBtn(true)
            const deviceUser = detectDevice()
            try {
                const response = await axios.post(process.env.REACT_APP_API + "/pay_routes/create_paiement", {
                    username: credentials.name,
                    firstname: credentials.firstname,
                    email: credentials.email,
                    name: select.name,
                    token_brand: brand,
                    device:deviceUser,
                    aid: aid
                })


                if (response?.status == 200 && response?.data && response?.data?.link) {
                    setIframePay(response.data.link)
                    setLoadBtn(false)
                    return
                }
                setError(true)
                setLoadBtn(false)
            } catch (err) {
                setError(true)
                setLoadBtn(false)
            }

        }
    }
    const handleSelect = (e) => {
        setSelect(e)
    }
    const calculPremiumTime = () => {
        const monAddSelect = select.month_add;

        if (credentials.lastDatePremium) {
            const dateToCompare = moment(credentials.lastDatePremium); // Date à comparer
            if (dateToCompare.isValid()) {
                const now = moment(); // Date actuelle
                const isBefore = dateToCompare.isBefore(now)
                if (isBefore) {
                    return moment().add(monAddSelect, 'months').format('DD/MM/YYYY');
                }
            }
            return dateToCompare.add(monAddSelect, 'months').format("DD/MM/YYYY");
        } else {
            return moment().add(monAddSelect, 'months').format('DD/MM/YYYY');
        }
    }

    const showCurrentPremium = () => {
        if (credentials.lastDatePremium) {
            const dateToCompare = moment(credentials.lastDatePremium); // Date à comparer
            if (dateToCompare.isValid()) {
                const now = moment(); // Date actuelle
                const isBefore = dateToCompare.isBefore(now)


                if (!isBefore) {
                    return dateToCompare.format('DD/MM/YYYY');
                }
            }
        }
        return ""
    }

    function calculateDiscountPercentage(amount, finalPrice) {
        if (amount <= 0 || finalPrice < 0 || finalPrice > amount) {
            throw new Error("Valeurs invalides.");
        }

        const discountPercentage = ((amount - finalPrice) / amount) * 100;
        return discountPercentage.toFixed(2); // Retourne avec 2 décimales
    }


    useEffect(() => {
        const handleMessage = (event) => {
            console.log(event.data);
            try {
                if (event?.data?.urlRedirect) {
                    setIframePay("")
                    window.location.href = event?.data?.urlRedirect
                }
                if (event?.data?.closeIframe) {
                    setIframePay("")
                }
            } catch (err) {

            }
        };

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);

    useEffect(() => {
        init();
    }, [])



    return (
        <div className='container-product'>
            {load && (
                <div className='df aic jcc py6 df fdc'>
                    <p className='fb mb3 cw'>Chargement des données</p>
                    <Loader />
                </div>
            )}
            {errorProduct&&(
                <div className='df aic jcc py6 px3 df fdc'>
                    <p className='mb3 cw fb tac'>Une erreur est survenue</p>
                    <BtnStandard label={"Réessayer"} click={()=>{
                       window.location.reload();
                    }}/>
                </div>
            )}
            {!load&& !errorProduct&& (
                <>
                    {product && (
                        <div className=' df fdc wrapper py4'>
                            <p className='fbb cw fs30 mb3'>Paiement</p>
                            <div className='cart-container'>
                                <div className='container-products df fdc w100'>
                                    <p className='cw fb '>Informations</p>
                                    <p className='cw fl mb3'>Nous avons besoin d'information</p>
                                    <div className='by-blue mb2'>
                                        <div className='item-info fr'>
                                            <div className='f-item-input fr df aic'>
                                                <label className={`label-input-sub ${!credentials.firstname ? "is-error" : ""} `}>
                                                    <input name="firstname" type="text" placeholder="Votre nom" value={credentials.firstname} onChange={(e) => handleChange(e)}></input>
                                                    <p className='cs fr fs12'>Merci de remplir ce champ</p>
                                                </label>
                                                <label className={`label-input-sub ${!credentials.name ? "is-error" : ""} `}>
                                                    <input name="name" type="text" placeholder="Votre prénom" value={credentials.name} onChange={(e) => handleChange(e)}></input>
                                                    <p className='cs fr fs12'>Merci de remplir ce champ</p>
                                                </label>
                                            </div>
                                            <label className={`label-input-sub ${!credentials.email ? "is-error" : ""} `}>
                                                <input name="email" type='email' placeholder="Votre email" value={credentials.email} onChange={(e) => handleChange(e)}></input>
                                                <p className='cs fr fs12'>Merci de remplir ce champ</p>
                                            </label>
                                        </div>
                                    </div>
                                    <p className='fb cw fs15 cw'>Selectionnés un produit</p>
                                    <p className='fl cw mb3'>Notre sélection de produit pour {product?.length > 0 && <span className='fbb'>{product[0].brand}</span>}</p>
                                    <div className='list-article'>
                                        {product?.map((el, i) => (
                                            <button onClick={() => handleSelect(el)} key={i + "_product"} className={`cw card-product w100 df aifs jcsb mb2 ${select && select.name == el.name ? "is-active" : ""} `}>
                                                <div className='df aifs'>
                                                    <div className='checking mr3'>
                                                        <span></span>
                                                    </div>
                                                    <div className='mr1 logo-brand-container'>
                                                        <img className='of-contain logo-item' src={process.env.REACT_APP_API + el.img}></img>
        
                                                    </div>
                                                    <div className='tal'>
        
                                                        <p className='fb'>{el.brand}</p>
                                                        {el.discount && (
                                                            <div className='remise'>
                                                                <p className='fr fs12'>Remise -{calculateDiscountPercentage(el.amout, el.discount)}%</p>
                                                            </div>
                                                        )}
                                                        <p className='fr'>{el.label}</p>
                                                    </div>
                                                </div>
                                                <div className={`df aic price-target ${el.discount ? "is-discount" : ""}`}>
                                                    {el.discount && (
                                                        <p className='fbb fs25 price-discount  mr2'>{el.discount}<span className='fr fs20'>€</span></p>
                                                    )}
                                                    <p className='price-amount fr  fs20'>{el.amout}€</p>
        
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                    {select && (
                                        <div className='mob-add-info'>
                                            <div className="item-pay">
                                                <div className='df aic items-paiement-list mb2 '>
                                                    <img src={paiement1} alt="mastercard" ></img>
                                                    <img src={paiement2} alt="visa" ></img>
                                                    <img src={paiement3} alt="google pay" ></img>
                                                    <img src={paiement4} alt="apple pay" ></img>
                                                </div>
                                                <p className='fb cw'>Effectuez vos paiements en toute sécurité</p>
                                                <p className='fl cw'>Notre système bénéficie d'un cryptage sécurisé grâce à notre partenaire</p>
                                            </div>
        
                                            {showCurrentPremium() && (
                                                <div className='item-pay'>
                                                    <div>
                                                        <p className='fbb cw'>Votre compte premium arrive a expiration le </p>
        
                                                    </div>
                                                    <div className='df fdc mt1'>
                                                        {showCurrentPremium() && (
                                                            <span className='mb1 corange fr'>{showCurrentPremium()}</span>
                                                        )}
        
                                                    </div>
        
                                                </div>
                                            )}
                                            <div className='item-pay df fdc' >
                                                <div>
                                                    <p className='fbb cw'>Date fin premium après paiement</p>
        
                                                </div>
                                                <div className='df mt1'>
                                                    <p className='bcw  cb px2 py1 fs12 fr'>{calculPremiumTime()}</p>
        
                                                </div>
        
        
        
                                            </div>
                                            <div className='item-pay'>
                                                <p className='fb fs18 cw df aic jcsb'>Total <span className='fb fs30'>{select.discount || select.amout}€</span></p>
                                            </div>
        
                                        </div>
                                    )}
                                </div>
        
                                <div className='cart-pay'>
                                    <div style={{ opacity: (credentials.name && credentials.firstname && credentials.email ? "" : "0.3") }} className='mb3 df jcfe desk-pay '>
                                        {loadBtn ? <Loader /> : (
                                            <BtnStandard click={submit} label={"Payer"} />
        
                                        )}
                                    </div>
                                    {select && (
                                        <>
                                            <div className='detail-cart-pay'>
                                                <div className='cw card-product w100 df fdc'>
                                                    <div className=' df aifs jcsb'>
                                                        <div className='df aifs'>
                                                            <div className='mr1 logo-brand-container'>
                                                                <img className='of-contain logo-item' src={process.env.REACT_APP_API + select.img}></img>
                                                            </div>
                                                            <div>
                                                                <p className='fb'>{select.brand}</p>
                                                                {select.discount && (
                                                                    <div className='remise'>
                                                                        <p className='fr fs12'>Remise -{calculateDiscountPercentage(select.amout, select.discount)}%</p>
                                                                    </div>
                                                                )}
                                                                <p className='fr'>{select.label}</p>
                                                            </div>
                                                        </div>
                                                        <div className={`df aic price-target ${select.discount ? "is-discount" : ""}`}>
                                                            {select.discount && (
                                                                <p className='fbb fs25  price-discount mr2'>{select.discount}<span className='fr fs20'>€</span></p>
                                                            )}
                                                            <p className='price-amount fr fs20'>{select.amout}€</p>
        
                                                        </div>
                                                    </div>
                                                    <div className='mt1'>
                                                    <p className='fr cw fs12'>Profitez d'un visionnage sans publicité sur l'ensemble du site</p>
                                                    <p className='fr cw fs12'>Sans engagement, renouvelez votre abonnement à votre rythme</p>
                                                    </div>
                                                </div>
                                                <div className="item-pay">
                                                    <div className='df aic items-paiement-list mb2 '>
                                                        <img src={paiement1} alt="mastercard" ></img>
                                                        <img src={paiement2} alt="visa" ></img>
                                                        <img src={paiement3} alt="google pay" ></img>
                                                        <img src={paiement4} alt="apple pay" ></img>
                                                    </div>
                                                    <p className='fb cw'>Effectuez vos paiements en toute sécurité</p>
                                                    <p className='fl cw'>Notre système bénéficie d'un cryptage sécurisé grâce à notre partenaire</p>
                                                </div>
        
                                                {showCurrentPremium() && (
                                                    <div className='item-pay'>
                                                        <div>
                                                            <p className='fbb cw'>Votre compte premium arrive a expiration le </p>
        
                                                        </div>
                                                        <div className='df fdc mt1'>
                                                            {showCurrentPremium() && (
                                                                <span className='mb1 corange fr'>{showCurrentPremium()}</span>
                                                            )}
        
                                                        </div>
        
                                                    </div>
                                                )}
                                                <div className='item-pay df fdc' >
                                                    <div>
                                                        <p className='fbb cw'>Date fin premium après paiement</p>
        
                                                    </div>
                                                    <div className='df mt1'>
                                                        <p className='bcw  cb px2 py1 fs12 fr'>{calculPremiumTime()}</p>
        
                                                    </div>
        
        
        
                                                </div>
                                                <div className='item-pay'>
                                                    <div className={`df aic jcsb w100 price-target ${select.discount ? "is-discount" : ""}`}>
                                                        <p className='cw fb fs18 '>Total</p>
                                                        <div className='df aic'>
                                                            {select.discount && (
                                                                <p className='fb fs30 fsmd20 mr2 cw'>{select.discount}€</p>
                                                            )}
                                                            <p className='fb price-amount fs18 fsmd14 cw df aic jcsb'> <span className='fb fs30'>{select.amout}€</span></p>
        
                                                        </div>
        
                                                    </div>
                                                    <p className='fl cw fs12'>Le taux de conversion USD vers EUR peut entraîner des frais supplémentaires, qui ne sont pas inclus dans le prix final.</p>
                                                </div>
        
                                            </div>
                                            <div style={{ opacity: (credentials.name && credentials.firstname && credentials.email ? "" : "0.3") }} className='mt3 df jcfe'>
                                                {loadBtn ? <Loader /> : (
                                                    <BtnStandard click={submit} label={"Payer"} />
        
                                                )}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}
                    {iframePay && (
                        <div className='modal-iframe-pay df aic jcc'>
                            <div className='overlay-iframe-pay'></div>
                            <div className='p-r container-pay-iframe'>
                                <button className='btn-close' onClick={() => setIframePay("")}>
                                    <img src={close} alt="close" style={{ height: "30px", width: "30px", objectFit: "contain" }}></img>
                                </button>
                                <div className='scroller-iframe'>
                                    <p className='cw fr tac'>Faites défiler vers le bas pour confirmer votre paiement.</p>
                                </div>
                                <iframe ref={iframeRef} src={iframePay} className='iframe-pay'></iframe>
                            </div>
                        </div>
                    )}
                    {error && (
                        <div className='adverti-block'>
                            <div className='overlay-adv' onClick={() => setError(false)}></div>
                            <div className='content-adverti df aic jcc fdc'>
                                <button className='btn-close' onClick={() => setError(false)}>
                                    <img src={close} alt="close" style={{ height: "30px", width: "30px", objectFit: "contain" }}></img>
                                </button>
        
        
                                <p className='fr cb fs15'>Nous sommes désolé </p>
                                <p className='cb fb fs16'>Une erreur est survenue</p>
                                <p className='cb fr fs14'>Veuillez réessayer</p>
        
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default ProductPay;